<template>
  <div>
    <div style="padding: 20px">
      <el-form size="small" ref="formRef" :model="formData" :rules="rules" label-width="80px">
        <el-col :span="12">
          <el-form-item label="日期" prop="bill_date" :error="errMsg.bill_date">
            <el-date-picker v-model="formData.bill_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 280px" :disabled="isView"> </el-date-picker>
          </el-form-item>
          <el-form-item label="名称" prop="name" :error="errMsg.name">
            <el-input v-model="formData.name" style="width: 280px" :disabled="isView"></el-input>
          </el-form-item>
          <el-form-item label="客户" prop="customer_id" :error="errMsg.customer_id">
            <Customer v-model="formData.customer_id" style="width: 280px" :disabled="isView"></Customer>
          </el-form-item>
          <el-form-item label="业务员" prop="employee_id" :error="errMsg.employee_id">
            <employee-select v-model="formData.employee_id" style="width: 280px" :disabled="isView"></employee-select>
          </el-form-item>
          <el-form-item label="附件" prop="fileList" :error="errMsg.fileList">
            <div style="width: 280px; display: flex; flex-wrap: wrap; gap: 5px">
              <div class="thumbnail-container" v-for="(item, index) in formData.fileList" :key="index">
                <el-image class="image" :src="item.url" v-if="item.types == 'img'"> </el-image>
                <el-card shadow="never" :body-style="{ padding: '0px' }" class="att" v-else><i class="el-icon-paperclip icon"></i></el-card>
                <div class="action-buttons">
                  <i class="el-icon-zoom-in icon" @click="handlePictureCardPreview({ url: item.url })" v-if="item.types == 'img'"></i>
                  <i class="el-icon-download icon" @click="handleDownload(item.url)"></i>
                  <i class="el-icon-delete icon" @click="handleRemove(index)" v-if="!isView"></i>
                </div>
              </div>
              <uploads @change="handleChange" v-if="!isView"></uploads>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="金额" prop="amount" :error="errMsg.amount">
            <el-input v-model="formData.amount" style="width: 280px" :disabled="isView"></el-input>
          </el-form-item>
          <el-form-item label="成本" prop="cost" :error="errMsg.cost">
            <el-input v-model="formData.cost" style="width: 280px" :disabled="isView"></el-input>
          </el-form-item>
          <el-form-item label="定金" prop="deposit" :error="errMsg.deposit">
            <el-input v-model="formData.deposit" style="width: 280px" :disabled="isView"></el-input>
          </el-form-item>
          <el-form-item label="是否退款" prop="is_succ" :error="errMsg.is_refund">
            <el-select v-model="formData.is_refund" placeholder="请选择" style="width: 280px" :disabled="isView">
              <el-option label="否" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark" :error="errMsg.remark">
            <el-input type="textarea" :rows="3" maxlength="2000" show-word-limit v-model="formData.remark" style="width: 280px" :disabled="isView"></el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <div class="form-but">
      <el-button type="primary" :loading="loading" @click="saveData()" v-if="!isView">保 存</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import uploads from '@/components/storage/uploads';
import Customer from '@/components/customer/select.vue';
import EmployeeSelect from '@/components/employee/select';
export default {
  name: 'docSave',
  components: {
    uploads,
    Customer,
    EmployeeSelect
  },
  props: {
    isView: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  data() {
    return {
      loading: false,
      formData: {
        id: 0,
        name: '',
        bill_date: '',
        amount: '',
        cost: '',
        deposit: '',
        is_refund: 0,
        employee_id: '',
        customer_id: '',
        fileList: [],
        remark: ''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        types: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        fileList: [{ required: true, message: '请上传文件', trigger: 'blur' }]
      },
      errMsg: {},
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  methods: {
    //上传成功传递数据
    handleChange(file) {
      const url = process.env.VUE_APP_API_URL + '/admin/storage/file/output?filename=' + file.filePath + '&token=' + this.$token();
      const item = { types: file.type, url: url, file_path: file.filePath };
      this.formData.fileList.push(item);
    },
    //删除
    handleRemove(i) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.formData.fileList.splice(i, 1);
        })
        .catch(() => {});
    },
    //浏览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //下载
    handleDownload(url) {
      const link = document.createElement('a');
      link.href = url + '&is_dow=1';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 保存数据
    async saveData() {
      this.$refs.formRef.validate(async vaild => {
        if (!vaild) return;
        this.setEmptyErrMsg();
        this.loading = true;
        let data = _.cloneDeep(this.formData);
        data.fileList = JSON.stringify(data.fileList);
        await this.$api.docExpenseClaim.save(data).then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.$emit('callMethod');
          } else {
            for (let k in res.data) {
              this.errMsg[k] = res.data[k];
            }
          }
        });
      });
    },
    //初始化错误信息对象
    setEmptyErrMsg() {
      this.errMsg = {};
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '');
      });
    },
    //获取信息
    setData(id) {
      this.formData.id = id;
      this.getData();
    },
    // 获取数据
    async getData() {
      await this.$api.docExpenseClaim.info({ id: this.formData.id }).then(res => {
        if (res.code == 200 && res.data) {
          this.formData.name = res.data.name;
          this.formData.employee_id = res.data.employee_id;
          this.formData.customer_id = res.data.customer_id;
          this.formData.bill_date = res.data.bill_date;
          this.formData.amount = res.data.amount;
          this.formData.cost = res.data.cost;
          this.formData.deposit = res.data.deposit;
          this.formData.is_refund = res.data.is_refund;
          this.formData.remark = res.data.remark;
          this.formData.fileList = [];
          res.data.file_list.forEach(file => {
            const url = process.env.VUE_APP_API_URL + '/admin/storage/file/output?filename=' + file.file_path + '&token=' + this.$token();
            const item = { types: file.types, url: url, file_path: file.file_path };
            this.formData.fileList.push(item);
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.thumbnail-container {
  position: relative;
  display: inline-block;
  height: 100px;
}
.thumbnail-container:hover .action-buttons {
  display: flex;
}
.action-buttons {
  display: none;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  position: absolute;
  top: 0;
  right: 0;
}
.action-buttons .icon {
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
.image {
  width: 100px;
  height: 100px;
  border-radius: 4px;
}
.att {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  background-color: #f2f6fc;
}
.att .icon {
  font-size: 48px;
  font-weight: bold;
  color: #e6a23c;
}
</style>
